import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, setApiKeyToObject, toPathString } from '../common.mjs';
import { BASE_PATH, BaseAPI } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CustomerJobGroupPublicControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 고객사의 직군 리스트 퍼블릭 조회
     * @param {CustomerJobGroupPublicControllerApiGetCustomerJobGroupsAsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerJobGroupsAsPublic: ({ customerIdHash }, options = {}) => {
      assertParamExists("getCustomerJobGroupsAsPublic", "customerIdHash", customerIdHash);
      const localVarPath = "/api-public/v2/recruiting/customers/{customerIdHash}/job-groups".replace("{".concat("customerIdHash", "}"), encodeURIComponent(String(customerIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setApiKeyToObject(localVarHeaderParameter, "WS_AID", configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return __spreadProps(__spreadValues({}, localVarRequestOptions), {
        identifier: "getCustomerJobGroupsAsPublic",
        url: toPathString(localVarUrlObj)
      });
    }
  };
};
const CustomerJobGroupPublicControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = CustomerJobGroupPublicControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 고객사의 직군 리스트 퍼블릭 조회
     * @param {CustomerJobGroupPublicControllerApiGetCustomerJobGroupsAsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerJobGroupsAsPublic(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getCustomerJobGroupsAsPublic(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const CustomerJobGroupPublicControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = CustomerJobGroupPublicControllerApiFp(configuration);
  return {
    /**
     * 고객사의 직군 리스트 퍼블릭 조회
     * @param {CustomerJobGroupPublicControllerApiGetCustomerJobGroupsAsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerJobGroupsAsPublic(requestParameters, options) {
      return localVarFp.getCustomerJobGroupsAsPublic(requestParameters, options)(axios, basePath);
    }
  };
};
class CustomerJobGroupPublicControllerApi extends BaseAPI {
  /**
   * 고객사의 직군 리스트 퍼블릭 조회
   * @param {CustomerJobGroupPublicControllerApiGetCustomerJobGroupsAsPublicRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerJobGroupPublicControllerApi
   */
  getCustomerJobGroupsAsPublic(requestParameters, options) {
    return CustomerJobGroupPublicControllerApiFp(this.configuration).getCustomerJobGroupsAsPublic(requestParameters, options)(this.axios, this.basePath);
  }
}
const getCustomerJobGroupsAsPublicRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: CustomerJobGroupPublicControllerApiAxiosParamCreator().getCustomerJobGroupsAsPublic,
  requestFn: CustomerJobGroupPublicControllerApiFp().getCustomerJobGroupsAsPublic
});

export { CustomerJobGroupPublicControllerApi, CustomerJobGroupPublicControllerApiAxiosParamCreator, CustomerJobGroupPublicControllerApiFactory, CustomerJobGroupPublicControllerApiFp, getCustomerJobGroupsAsPublicRemote };
//# sourceMappingURL=customer-job-group-public-controller-api.mjs.map
